import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    <span>CICS</span>&nbsp;on&nbsp;GitHub
  </Header>
);

export default CustomHeader;
